import { graphLabelText, graphNodeLabel, graphValueText } from './';
export const graphNodeGroupTitle = (theme, parameters) => {
  const labelText = graphLabelText(theme, parameters);
  const valueText = graphValueText(theme, parameters);
  const common = {
    fontFamily: labelText.fontFamily,
    fontSize: labelText.fontSize,
    fontStyle: valueText.fontStyle,
    fontWeight: valueText.fontWeight,
    textColor: graphNodeLabel(theme, parameters).textColor
  };
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          ...common
        };
      }
    case 'high-contrast':
      {
        return {
          ...common
        };
      }
    default:
      {
        return {
          ...common
        };
      }
  }
};
//# sourceMappingURL=graphNodeGroupTitle.js.map